"use client";

import { useState } from "react";
import { useSelector } from "react-redux";
import ICON_ARROW_UP from "@/assets/images/arrow-up.svg";
import ICON_CORNER from "@/assets/images/icon-corner.svg";

const GRID_COLUMNS_HALF1 = "70px 55px 40px 2fr 1fr";

export default function OddsMatchLeagues({ league, matches, banner, render = () => {} }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const oddsPeriod = useSelector((state) => state.oddsPeriodReducer) || "full";
  const isHalf1 = oddsPeriod === "half1";

  return (
    <div className="flex flex-col w-full bg-[var(--theme-foreground)] overflow-hidden mb-0.5">
      <div
        className="kbv-league-head flex items-center gap-2.5 px-2.5 py-1.5 cursor-pointer select-none border-b border-[var(--theme-border)]  md:h-[44px]"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {league.logo && (
          <img src={league.logo} alt="" className="w-[24px] h-[24px] object-contain shrink-0" loading="lazy" />
        )}
        <span className="text-xs font-bold uppercase flex-1 truncate">{league.name}</span>
        <img
          src={ICON_ARROW_UP}
          alt=""
          className={`w-[14px] h-[14px] transition-transform ${isExpanded ? "" : "rotate-180"}`}
        />
      </div>

      {isExpanded && (
        <>
          <div
            className="kbv-table-head kbv-grid-row hidden md:grid w-full border-b border-[var(--theme-border)] font-semibold uppercase min-h-[44px]"
            style={isHalf1 ? { gridTemplateColumns: GRID_COLUMNS_HALF1 } : undefined}
          >
            <div className="flex items-center justify-center border-r border-[var(--theme-border)]">Thời gian</div>
            <div className="flex items-center justify-center border-r border-[var(--theme-border)]">Tỉ số</div>
            <div className="flex items-center justify-center border-r border-[var(--theme-border)]">
              <img src={ICON_CORNER} alt="corner" className="w-[14px] h-[14px]" />
            </div>
            <div className="flex items-center justify-start px-2 py-1 border-r border-[var(--theme-border)]">Đội bóng</div>
            {/* Hiệp 1 */}
            <div className={`flex flex-col ${isHalf1 ? "" : "border-r border-[var(--theme-border)]"}`}>
              <div className="kbv-table-subhead flex items-center justify-center py-0.5 border-b border-[var(--theme-border)] text-xs">Hiệp 1</div>
              <div className="kbv-col-odds flex-1 items-center">
                <div className="flex items-center justify-center text-xs">Cược Chấp</div>
                <div className="flex items-center justify-center text-xs">Tài/Xỉu</div>
                <div className="flex items-center justify-center text-xs">1×2</div>
              </div>
            </div>
            {/* Toàn trận - ẩn khi chọn Hiệp 1 */}
            {!isHalf1 && (
              <div className="flex flex-col">
                <div className="kbv-table-subhead flex items-center justify-center py-0.5 border-b border-[var(--theme-border)] text-xs">Toàn trận</div>
                <div className="kbv-col-odds flex-1 items-center">
                  <div className="flex items-center justify-center text-xs">Cược Chấp</div>
                  <div className="flex items-center justify-center text-xs">Tài/Xỉu</div>
                  <div className="flex items-center justify-center text-xs">1×2</div>
                </div>
              </div>
            )}
          </div>

          {/* Match */}
          <div className="flex flex-col w-full">
            {matches.map((match, index) => (
              <div key={match.id}>
                {render(match, index)}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
